/**
 * Leer-Floskeln der Live-Mitschrift — EINE Liste für Browser und Server.
 * (12.10.2026, Bahn live-primaer: bis dahin stand sie nur in frontend/lib/live-dictation.ts; der Server braucht sie
 * jetzt für die Regel „Kontext“ in server/live-primaer.ts — nicht kopiert, sondern hierher gehoben.)
 */

/**
 * 2026-07-29 (Martin: "Warum kommt immer das Scheiss-Wiener Neustadt?"):
 *
 * Der PTT-Weg verwirft solche Halluzinationen serverseitig — im Protokoll
 * steht dort sauber: verworfen (leer/echo/stille): "Wiener Nesadt.". Das
 * Live-Diktat lief aber DIREKT vom Browser zu Soniox; der Server sieht
 * diesen Text nie, also greift dort auch kein Filter. Zwei von drei
 * Erkennungswegen filterten, der dritte nicht — dieselbe Krankheit wie bei
 * den Wortlisten, nur eine Ebene hoeher.
 *
 * Deshalb hier dieselbe Pruefung am Ort, wo der Text entsteht. Bewusst nur
 * auf dem FERTIGEN Text (nicht auf Zwischenstaenden) und nur, wenn er
 * VOLLSTAENDIG aus einer bekannten Floskel besteht — ein "Danke" mitten in
 * einem Satz bleibt unangetastet.
 */
export const DIKTAT_FLOSKELN: ReadonlySet<string> = new Set([
  "aplausos",
  "applaus",
  "applause",
  "musik",
  "music",
  "untertitel",
  "untertitelung",
  "untertitelung des zdf",
  "untertitel im auftrag des zdf",
  "amara org",
  "thanks for watching",
  "thank you",
  "gracias",
  "you",
  // Ortsnamen aus dem Erkennungs-Wortschatz, die bei Stille als
  // Halluzination auftauchen — Martin hat sie nie gesagt.
  "wiener neustadt",
  "wiener nesadt",
  "hollenthon",
  "wien",
]);

/** Unscharf (bis zu zwei Abweichungen) wird erst ab so vielen Zeichen verglichen — kürzere Floskeln gelten nur genau. */
export const FLOSKEL_UNSCHARF_AB = 5;

/** Ist der GANZE Text nur eine bekannte Leer-Floskel? */
export function istDiktatFloskel(text: string): boolean {
  const kern = text
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]+/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!kern) return true;
  if (DIKTAT_FLOSKELN.has(kern)) return true;
  // Leichte Verstuemmelungen derselben Floskeln ("Nesadt" statt "Neustadt") — nur bei langen Woertern (23.10.2026):
  // zwei Abweichungen von „you“ oder „wien“ trafen kurze echte Woerter („wie“, „yo“) und gesprochene Buchstaben
  // („kju“ = Q, „ooh“ = O, „yot“ = J, „wee“ = W) — Morse „Augen zu“ bekam sie als Stille zurueck.
  if (kern.length < FLOSKEL_UNSCHARF_AB) return false;
  for (const f of DIKTAT_FLOSKELN) {
    if (f.length < FLOSKEL_UNSCHARF_AB || Math.abs(f.length - kern.length) > 2) continue;
    let unterschiede = 0;
    const n = Math.max(f.length, kern.length);
    for (let i = 0; i < n; i++) {
      if (f[i] !== kern[i]) unterschiede++;
      if (unterschiede > 2) break;
    }
    if (unterschiede <= 2) return true;
  }
  return false;
}
